import "./ModalComponent.css";
// import "react-datepicker/dist/react-datepicker.css";

import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import DatePicker from 'react-date-picker';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import TableComponent from "../TableComponent/TableComponent";
import checkMarkIcon from "../../../assets/check-icon.png";
import fileIcon from "../../../assets/file-icon.png";
import uploadIcon from "../../../assets/upload-icon.png";
import Select from 'react-select';
import { customStyles } from "./MultiSelectStyle";
import moment from "moment";
import { DataTableComponent } from "../../common/TableComponent/DataTableComponent";
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'

const ModalComponent = ({
    isOpen,
    onClose,
    fieldsData,
    onChangeInput,
    buttons,
    modalTitle,
    dropdownOptions,
    formData,
    onChangeDate,
    handleDocumentHistory,
    onViewDoc,
    modalType,
    modalText,
    onChangeMultiselect,
    columns,
    onChangePhoneNumber,
    modalStyle
}) => {
    const { t } = useTranslation();
    const [progress, setProgress] = useState(0);
    const [selectedFile, setSelectedFile] = useState(null);

    useEffect(() => {
        !isOpen || setProgress(0);
        !isOpen || setSelectedFile(null);
    }, [isOpen]);

    if (!isOpen) return null;

    const handelChangeInput = (e, field) => {
        const { name, value, files } = e.target;
        onChangeInput && onChangeInput(e.target, field);
        if (files && files[0]) {
            simulateFileUpload(files);
            setSelectedFile(files[0]);
        }
    };

    const handelChangePhoneNo = (value) => {
        onChangePhoneNumber && onChangePhoneNumber(value);
    }

    const handleDateChange = (date, name) => {
        onChangeDate(date, name);
    };

    const simulateFileUpload = (file) => {
        let uploaded = 0;
        const total = file[0]?.size;
        const interval = setInterval(() => {
            uploaded += total * 0.1;
            setProgress(Math.min((uploaded / total) * 100, 100));
            if (uploaded >= total) {
                clearInterval(interval);
            }
        }, 100);
    };

    const handleChangeMultiSelect = (selected, label) => {
        onChangeMultiselect(selected, label);
    };

    return (
        <div className={["modal", "overlayStyle"].join(" ")}>
            <div className="modalStyle" style={modalStyle?.width && { width: modalStyle?.width }}>
                <div className="modalHeader">
                    <span className="modalTitle">{modalTitle}</span>
                    <button
                        onClick={() => {
                            setProgress(0);
                            onClose();
                        }}
                        className="closeButtonStyle"
                    >
                        X
                    </button>
                </div>

                <div className="outerWrapper">
                    {fieldsData && fieldsData.length > 0 ? (
                        fieldsData?.map((item, index) => {
                            return (
                                <div className="fieldsOuterDiv">
                                    {item.fieldName ? (
                                        <div className="fieldName">
                                            {item?.fieldName}
                                            <span className="requiredText">
                                                {item.required === true && "*"}
                                            </span>
                                            :
                                        </div>
                                    ) : (
                                        <div>{item?.text}</div>
                                    )}
                                     {item.type === "multiInput" && (
                                    <div className="multiInputContainer">
                                        {item.fields.map((field, idx) => (
                                            <div key={idx} className="multiInputField">
                                                <span className="multiInputLabel">{field.label}</span>
                                                <input
                                                    name={field.name}
                                                    onChange={(e) => handelChangeInput(e, "input")}
                                                    type="text"
                                                    value={formData[field.name]}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                )}
                                    {item.type === "input" && (
                                        <input
                                            name={item?.name}
                                            onChange={(e) =>
                                                handelChangeInput(e, item?.type)
                                            }
                                            type="text"
                                            value={formData[item?.name]}
                                            className="inputField"
                                            readOnly={item?.readOnly === true}
                                        />
                                    )}

                                    {item.type === "phoneNumber" && (
                                        <PhoneInput
                                            name={item?.name}
                                            onChange={(value) =>
                                                handelChangePhoneNo(value)
                                            }
                                            international
                                            countryCallingCodeEditable={false}
                                            defaultCountry="IN"
                                            value={formData[item?.name]}
                                            className="inputField"
                                        />
                                    )}

                                    {item.type === "dropdown" && (
                                        <select
                                            value={formData[item?.name]}
                                            onChange={(e) =>
                                                handelChangeInput(e, item.type)
                                            }
                                            name={item.name}
                                            className="inputField select-dropdown"
                                            disabled={item?.isFieldDisabled}
                                        >
                                            {item?.options?.map(
                                                (option, index) => (
                                                    <option
                                                        key={index}
                                                        value={option.value}
                                                    >
                                                        {option.label}
                                                    </option>
                                                )
                                            )}
                                        </select>
                                    )}

                                    {item.type === 'multiselect' &&
                                        <>
                                            <Select
                                                isMulti
                                                options={item?.options}
                                                value={formData[item.name]}
                                                onChange={(selectedOption) => handleChangeMultiSelect(selectedOption, item.name)}
                                                isDisabled={item?.isFieldDisabled}
                                                styles={customStyles}
                                                className="inputField"
                                                placeholder={item?.placeholder}
                                            />
                                        </>
                                    }
                                    {item.type === "datepicker" && (
                                        // <DatePickerComponent />
                                        <>
                                           <DatePicker
                                            onChange={(date) => handleDateChange(date, item.name)}
                                            value={formData[item.name] ? moment(formData[item.name]).format('DD/MMM/YYYY') : null}
                                            format="dd/MM/yyyy"
                                            monthPlaceholder="mm"
                                            dayPlaceholder="dd"
                                            yearPlaceholder="yyyy"
                                            disabled={
                                                (modalType === 'edit' && item.name === 'startDate') ||
                                                (modalType === 'add' && item.name === 'endDate' && formData[item.name] === '') ||
                                                (modalTitle === t('surveyExtension') && item.name === 'startDate')
                                            }
                                            className={(modalType === 'add' && item.name === 'startDate') ? 'datepicker' : ''}
                                            minDate={
                                                (modalType === 'add' || modalTitle === t("publishSurvey"))
                                                    ? new Date()
                                                    : (modalTitle === t('surveyExtension') && item.name === 'endDate' && formData['startDate'])
                                                        ? new Date(formData['startDate'])
                                                        : undefined
                                            } // disables all past dates
                                        />
                                        </>
                                    )}
                                    {item.type === "inputWithCount" && (
                                        <div className="textAreaOuterDiv">
                                            <input
                                                name={item?.name}
                                                onChange={(e) =>
                                                    handelChangeInput(e, item?.type)
                                                }
                                                type="text"
                                                value={formData[item?.name]}
                                                className="inputField"
                                                readOnly={item?.readOnly === true}
                                                style={{ width: "100%" }}
                                            />

                                            <div
                                                style={{
                                                    fontSize: "12px",
                                                    color: "#888",
                                                    marginTop: "0.5em",
                                                    marginLeft: "1em",
                                                }}
                                            >
                                                {
                                                    (formData[item.name] || "")
                                                        .length
                                                }
                                                /255
                                            </div>
                                        </div>
                                    )}

                                    {item.type === "textareaWithCount" && (
                                        <div className="textAreaOuterDiv">
                                            <textarea
                                                name={item.name}
                                                onChange={(e) =>
                                                    handelChangeInput(e, item.type)
                                                }
                                                type="text"
                                                value={formData[item.name]}
                                                rows="5"
                                                className="inputField"
                                                disabled={item?.isFieldDisabled}
                                                style={{ width: "100%" }}
                                            />

                                            <div
                                                style={{
                                                    fontSize: "12px",
                                                    color: "#888",
                                                    marginTop: "0.5em",
                                                    marginLeft: "1em",
                                                }}
                                            >
                                                {
                                                    (formData[item.name] || "")
                                                        .length
                                                }
                                                /8000
                                            </div>
                                        </div>
                                    )}

                                    {item.type === "textarea" && (
                                        <textarea
                                            name={item.name}
                                            onChange={(e) =>
                                                handelChangeInput(e, item.type)
                                            }
                                            type="text"
                                            value={formData[item.name]}
                                            rows="5"
                                            className="inputField"
                                            disabled={item?.isFieldDisabled}
                                        />
                                    )}

                                    {item.type === "checkbox" && (
                                        <>
                                            <input
                                                type="checkbox"
                                                checked={formData[item.name]}
                                                onChange={(e) =>
                                                    handelChangeInput(e, item.type)
                                                }
                                                name={item.name}
                                                style={{
                                                    width: "20px",
                                                    height: "20px",
                                                    marginLeft: "0px"
                                                }}
                                            />
                                        </>
                                    )}

                                    {item.type === "file" &&
                                        (item.showUploadIcon ? (
                                            // Upload Icon Section (No border)
                                            <label
                                                htmlFor={`fileUpload-${index}`}
                                                className="uploadBox"
                                            >
                                                <input
                                                    type="file"
                                                    id={`fileUpload-${index}`}
                                                    name={item.name}
                                                    className="fileInput"
                                                    onChange={(e) =>
                                                        handelChangeInput(
                                                            e,
                                                            item.name
                                                        )
                                                    }
                                                    style={{ display: "none" }}
                                                />
                                                <img
                                                    src={uploadIcon}
                                                    alt="Upload Icon"
                                                    className="uploadIcon"
                                                />
                                                <span className="uploadText">
                                                    {selectedFile &&
                                                        selectedFile.name}
                                                </span>
                                            </label>
                                        ) : (
                                            <label className="fileUploadLabel">
                                                <input
                                                    type="file"
                                                    id={`fileUpload-${index}`}
                                                    name={item.name}
                                                    className="fileInput"
                                                    onChange={(e) =>
                                                        handelChangeInput(
                                                            e,
                                                            item.name
                                                        )
                                                    }
                                                    style={{ display: "none" }}
                                                    accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,text/plain,text/csv,application/rtf,image/jpeg,image/png,image/gif,image/svg+xml,image/tiff"

                                                />
                                                <input
                                                    type="text"
                                                    className="fileNameInput"
                                                    value={
                                                        selectedFile
                                                            ? selectedFile.name
                                                            : ""
                                                    }
                                                    readOnly

                                                />
                                                <span className="browseButton">
                                                    {t("browseFile")}
                                                </span>
                                            </label>
                                        ))}
                                    {item.type === "progress" && (
                                        <div className="progressWrapper">
                                            <div className="progressTopRow">
                                                <img
                                                    src={fileIcon}
                                                    alt="File Icon"
                                                    className="fileIcon"
                                                />
                                                <span className="fileName">
                                                    {selectedFile &&
                                                        selectedFile?.name}
                                                </span>
                                                {progress == 100 && (
                                                    <img
                                                        src={checkMarkIcon}
                                                        alt="Checkmark Icon"
                                                        className="checkMark"
                                                    />
                                                )}
                                            </div>
                                            <div className="progressBottomRow">
                                                <span className="fileSize">
                                                    {" "}
                                                    {(
                                                        selectedFile &&
                                                        selectedFile.size / 1024
                                                    )?.toFixed(1)}{" "}
                                                    KB
                                                </span>
                                                <progress
                                                    value={progress}
                                                    max="100"
                                                    className="progressBar"
                                                ></progress>
                                                <span className="progressPercent">
                                                    {progress}%
                                                </span>
                                            </div>
                                        </div>
                                    )}
                                    {item.type === "email" && (
                                        <input
                                            name={item.name}
                                            onChange={(e) =>
                                                handelChangeInput(e, item.type)
                                            }
                                            type="email"
                                            value={formData[item.name]}
                                            className="inputField"
                                            disabled={item?.disabled}
                                        />
                                    )}
                                    {item.type === "" && (
                                        <span>{item.fieldValue}</span>
                                    )}
                                </div>
                            );
                        })
                    ) : formData && formData.length > 0 ? (
                        <DataTableComponent
                            tableName="versionInfo"
                            onViewDoc={onViewDoc}
                            columns={columns}
                            data={formData}
                            pageCount={5}
                        />
                    ) : (
                        <div className={modalStyle?.textAlign === 'left' ? 'text-left' : "text-center"}>{modalText}</div>
                    )}
                    <div className="buttonsOuterDiv">
                        {buttons &&
                            buttons.map((button, index) => (
                                <span key={index}>{button}</span>
                            ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModalComponent;
